/* eslint-disable id-length */
import keyMirror from 'keymirror';

export default keyMirror({
  SOCIALFEED_SECTION_TITLE_RENDERED: null,
  SOCIALFEED_FOLLOW_LINK_RENDERED: null,
  INSTAGRAM_FEED_ITEM_RENDERED: null,
  DESKTOP_RENDER_CONTAINER: null,
  MOBILE_RENDER_CONTAINER: null,
  WIDGET_WRAPPER_SOCIALFEED: null
});
